import { Tooltip } from '@tunein/react-ui';
import { useContext } from 'react';
import {
  InteractiveTileArea,
  InteractiveTileAreaContext,
} from 'src/common/components/containerItems/shared/InteractiveTileArea';
import { InfoIcon } from 'src/common/components/shared/svgIcons/InfoIcon';
import { useDiscordGeorestrictedUsersCountMessage } from 'src/common/hooks/useDiscordGeorestrictedUsersCountMessage';
import css from './discord-georestrictions-tooltip.module.scss';

export function DiscordGeoRestrictionsInfoTooltip({ georestrictedUsersCountMessage }) {
  const isOpen = useContext(InteractiveTileAreaContext);

  return (
    <Tooltip
      delay={0}
      side="bottom"
      open={isOpen}
      content={<div className={css.tooltipContent}>{georestrictedUsersCountMessage}</div>}
      classNames={{
        popup: css.tooltipPopup,
        container: css.tooltipContainer,
      }}
      data-testid="discordGeoRestrictionsTooltip"
    >
      <div className={css.iconBackground}>
        <InfoIcon height="100%" width="100%" />
      </div>
    </Tooltip>
  );
}

export function DiscordGeoRestrictionsTileAreaTooltip({ guideItem }) {
  const georestrictedUsersCountMessage = useDiscordGeorestrictedUsersCountMessage(guideItem);

  if (!georestrictedUsersCountMessage) {
    return null;
  }

  return (
    <InteractiveTileArea>
      <DiscordGeoRestrictionsInfoTooltip
        georestrictedUsersCountMessage={georestrictedUsersCountMessage}
      />
    </InteractiveTileArea>
  );
}
